export default "__VITE_ASSET__CvgP5$Tc__"